export default {"src":"/_next/static/media/financial-report-blank.b00d9cab.svg","height":163,"width":130,"blurWidth":0,"blurHeight":0};